import type { Stave } from 'vexflow';

/** Recorta el SVG al pentagrama con margen mínimo (plica + compás). */
export function fitHostSvgToStave(
  host: HTMLDivElement,
  stave: Stave,
  canvasW: number,
  opts?: { top?: number; bottom?: number; left?: number; right?: number },
): void {
  const svg = host.querySelector('svg');
  if (!svg) return;

  const topPad = opts?.top ?? 22;
  const bottomPad = opts?.bottom ?? 18;
  const leftPad = opts?.left ?? 6;
  const rightPad = opts?.right ?? 12;

  const top = Math.max(0, stave.getYForLine(0) - topPad);
  const bottom = stave.getYForLine(4) + bottomPad;
  const left = Math.max(0, stave.getX() - leftPad);
  const right = Math.min(canvasW, stave.getX() + stave.getWidth() + rightPad);
  const width = Math.max(1, right - left);
  const height = Math.max(1, bottom - top);

  svg.setAttribute('viewBox', `${left} ${top} ${width} ${height}`);
  svg.removeAttribute('width');
  svg.removeAttribute('height');
  svg.style.display = 'block';
  svg.style.width = '100%';
  svg.style.height = 'auto';
  svg.style.maxWidth = '100%';
}

/** Recorte genérico para glifos aislados. */
export function fitHostSvgToContent(host: HTMLDivElement, padding = 6): boolean {
  const svg = host.querySelector('svg');
  if (!svg) return false;

  try {
    const bbox = svg.getBBox();
    if (bbox.width <= 0 || bbox.height <= 0) return false;

    const x = bbox.x - padding;
    const y = bbox.y - padding;
    const w = bbox.width + padding * 2;
    const h = bbox.height + padding * 2;

    svg.setAttribute('viewBox', `${x} ${y} ${w} ${h}`);
    svg.removeAttribute('width');
    svg.removeAttribute('height');
    svg.style.display = 'block';
    svg.style.width = '100%';
    svg.style.height = 'auto';
    svg.style.maxWidth = '100%';
    return true;
  } catch {
    return false;
  }
}
